<template>
  <div>
    <div v-for="option in localOptions" :key="option.id" class="row option-box py-3">
      <div class="col m-2 pt-2">
        {{ option.name }}
      </div>
      <div class="col--3">
        <input
          v-enter-to-tab
          type="text"
          class="form-control form-control--text numeric-input EnterToTab"
          :class="{'input-error': option.isInvalid}"
          :value="option.text"
          :readonly="viewMode"
          :maxlength="maxLength"
          @blur="answered()"
          @change="valueChange(option, $event)"
          @focus="selectAll($event)"
        />
      </div>
    </div>
    <div v-if="localOptions.some(option => option.isInvalid)" class="row mt-3">
      <div class="col d-flex input-error-label">
        <smtt-icon icon="info-circle" class="align-self-center mr-2"/>
        {{ $t('surveyQuestionScreen.openAnswerOption.errorMsgValidation') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NumericList",
  'props': {
    'questionId': 0,
    'answerName': '',
    'questionOptions': Array,
    'viewMode': {
      'type': Boolean,
      'required': false
    },
    'maxLength': null,
    'customValidation': {
      type: String,
      required: false,
    },
    // The validation mode can be: sum, nonzero, top
    'validationMode': {
      type: String,
      required: false,
    }
  },
  'methods': {
    valueChange(option, e) {
      // If we have the custom validation, we use it.

      const regex = this.customValidation ? new RegExp(this.customValidation, 'g') : /^\d+$/
      let element = e.target

      if (regex.test(element.value)) {
        element.value = element.value.slice(0, this.maxLength ?? 20)
        option.isInvalid = false;
      } else {
        element.value = this.customValidation ? '' : '0'
        option.isInvalid = true;
        e.preventDefault()
      }

      option.text = element.value

      if (this.validationMode) {
        // These validations expect only numeric values
        const hasNanValue = this.localOptions.some((option) => {
          return option.text && option.text !== '' && isNaN(parseInt(option.text))
        });

        if (hasNanValue) {
          option.isInvalid = true;
          return;
        }

        const flaggedOptionIndex = this.localOptions.findIndex((option) => parseInt(option.other) === 1);
        if (flaggedOptionIndex !== -1) {
          if (this.validationMode === 'sum') {
            const sum = this.localOptions.filter((option) => parseInt(option.other) !== 1)
              .map((option) => option.text ? parseInt(option.text) : 0)
              .reduce((a, b) => a + b, 0); 

            if (sum !== parseInt(this.localOptions[flaggedOptionIndex].text)) {
              this.localOptions[flaggedOptionIndex].isInvalid = true;
            } else {
              this.localOptions[flaggedOptionIndex].isInvalid = false;
            }
          }

          if (this.validationMode === 'nonzero') {
            this.localOptions[flaggedOptionIndex].isInvalid = parseInt(this.localOptions[flaggedOptionIndex].text) <= 0;
          }

          if (this.validationMode === 'top') {
            const maxNumber = Math.max(...this.localOptions.map((option) => option.text ? parseInt(option.text) : 0));
            this.localOptions[flaggedOptionIndex].isInvalid = parseInt(this.localOptions[flaggedOptionIndex].text) < maxNumber;
          }
        }
      }

    },
    answered() {
      if (this.viewMode) {
        return;
      }

      // Remove the custom field before we emit the event.
      const response = this.localOptions.map((option) => {
        delete option.isInvalid;
        return option;
      });

      this.$emit('onAnswered', response);
    },
    checkConditionals() {
      this.questionOptions.forEach((option) => {
        if (!(option.text)) {
          option.text = '0'
        }
      })
    },
    selectAll(event) {
      event.target.select();
    }
  },
  data() {
    return {
      'otherText': '',
      'localOptions': [],
    }
  },
  created() {
    this.otherText = this.answerName === null ? '' : this.answerName

    // Add a custom field to keep track if the answer is invalid.
    this.localOptions = this.questionOptions.map((option) => {
      return {
        ...option,
        isInvalid: false,
      }
    });
  },
  mounted() {
    this.checkConditionals()
  }
}
</script>

<style scoped>
.option-box {
  border-top: solid 2px #E3E3E3;
  border-bottom: solid 2px #E3E3E3;
}

.option-box + .option-box {
  border-top: none;
}

.option-box:nth-child(odd) {
  background-color: #FAFAFA;
}

.numeric-input {
  padding-right: 0.4rem;
  padding-left: 0.4rem;
  height: 36px !important;
  font-size: 1rem !important;
}

.form-control {
  box-shadow: none;
  background-color: rgb(255, 255, 255);
  height: 40px;
  font-size: 0.875rem;
  line-height: 1.5rem;
  flex: 1 1 auto;
  border: 1px solid rgb(76, 77, 87);
}

.input-error {
  border-color:#8e1f1f
}

.input-error-label {
  color:#8e1f1f
}

</style>